export default "__VITE_ASSET__CQvnamZ4__"